<a [href]="whatsappUrl" style="color: #fff" class="float" target="_blank">
  <i class="fab fa-whatsapp my-float"></i>
</a>
